import { render } from "./AddEmailPage.vue?vue&type=template&id=7303ccc0&ts=true"
import script from "./AddEmailPage.vue?vue&type=script&lang=ts"
export * from "./AddEmailPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/DanhGia_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__